import { Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useImpersonationStore } from '@/store/impersonation';

// Persistent banner shown while a super-admin is viewing the app as another user. Mounted
// once at the app root; self-hides when not impersonating.
export function ImpersonationBanner() {
  const { isImpersonating, impersonatedEmail, stop } = useImpersonationStore();

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="fixed top-0 inset-x-0 z-[60] flex items-center justify-center gap-3 bg-primary/90 px-4 py-2 text-sm text-primary-foreground backdrop-blur">
      <Eye className="h-4 w-4" />
      <span>
        Viewing as <span className="font-semibold">{impersonatedEmail}</span> (read-only)
      </span>
      <Button size="sm" variant="secondary" className="h-7" onClick={stop}>
        Exit
      </Button>
    </div>
  );
}
